import { createPortal } from 'react-dom';

export default function Portal({ children }) {
  const overlayRoot = document.getElementById('overlay-root');
  
  if (!overlayRoot) {
    return null;
  }
  
  return createPortal(children, overlayRoot);
}